// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Registration Success Shared Component Styles */

.reg-success-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: visible;
}

.reg-success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
  max-width: 728px;
  min-width: 0;
  overflow-x: visible;
  overflow-y: visible;
  box-sizing: border-box;
  padding: 0 20px;
}

@media (min-width: 768px) {
  .reg-success-content {
    padding: 0;
  }
}

.reg-success-message {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.5;
  color: #00254a;
  text-align: center;
  margin: 0;
}

.reg-success-school-name {
  font-weight: 600;
}

.reg-success-codes-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  min-width: 0;
}

@media (min-width: 768px) {
  .reg-success-codes-container {
    flex-direction: row;
    gap: 40px;
    justify-content: center;
  }
}

.reg-success-email-notice {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 18px;
  font-style: normal;
  line-height: 1.5; /* 150% = 27px */
  color: #00254a;
  text-align: center;
  margin: 0;
}

.reg-success-code-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex: 1;
  min-width: 0;
}

.reg-success-code-label {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.6;
  color: #1c60ea;
  text-align: center;
  margin: 0;
  width: 100%;
}

.reg-success-code-card {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.reg-success-code-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 12px 24px;
  background: #ffffff;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 0;
}

.reg-success-code-button:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(35, 108, 255, 0.15);
}

.reg-success-code-button:active {
  transform: scale(0.98);
}

.reg-success-code-button:focus-visible {
  outline: 2px solid #1c60ea;
  outline-offset: 2px;
}

.reg-success-code-text {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 28px;
  line-height: 1.3;
  color: #1c60ea;
  white-space: nowrap;
}

@media (min-width: 768px) {
  .reg-success-code-text {
    font-size: 40px;
  }
}

.reg-success-copy-icon {
  width: 28px;
  height: 28px;
  color: #1c60ea;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 768px) {
  .reg-success-copy-icon {
    width: 36px;
    height: 36px;
  }
}

.reg-success-copied-feedback {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #1c60ea;
  background: rgba(255, 255, 255, 0.95);
  padding: 4px 12px;
  border-radius: 12px;
  pointer-events: none;
  animation: fadeInOut 2s ease-in-out;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.reg-success-code-description {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.6;
  color: #00254a;
  text-align: center;
  margin: 0;
  max-width: 272px;
}

.reg-success-button-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;
}

@media (min-width: 768px) {
  .reg-success-button-container {
    flex-direction: row;
    justify-content: center;
    gap: 24px;
  }
}

.reg-success-done-button {
  width: 220px;
  height: 48px;
  padding: 10px 24px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.75em !important;
  border-radius: 9999px !important;
  background-color: transparent !important;
  color: #00254a !important;
  border: 2px solid #00254a !important;
  cursor: pointer;
  transition: all 0.2s ease !important;
  white-space: nowrap;
}

.reg-success-done-button:hover:not(:disabled) {
  background-color: rgba(0, 37, 75, 0.05) !important;
}

.reg-success-done-button:active:not(:disabled) {
  background-color: rgba(0, 37, 75, 0.1) !important;
}

.reg-success-view-challenge-button {
  width: 220px;
  height: 48px;
  padding: 10px 24px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.75em !important;
  border-radius: 9999px !important;
  background-color: #205ea3 !important;
  color: white !important;
  border: none !important;
  cursor: pointer;
  transition: all 0.2s ease !important;
  white-space: nowrap;
}

.reg-success-view-challenge-button:hover:not(:disabled) {
  background-color: #1a4d8a !important;
}

.reg-success-view-challenge-button:active:not(:disabled) {
  background-color: #154071 !important;
}


.reg-success-info-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px;
  background: rgba(35, 108, 255, 0.07);
  border-radius: 30px;
  overflow: hidden;
}

.reg-success-info-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  width: 100%;
}

@media (min-width: 768px) {
  .reg-success-info-content {
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }
}

.reg-success-info-question {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 1.5;
  color: #1c60ea;
  white-space: nowrap;
  flex-shrink: 0;
}

.reg-success-info-contact {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5;
  color: #00254a;
  flex: 1;
}

.reg-success-info-link {
  color: #00254a;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
  font-weight: 600;
  transition: color 0.2s ease;
}

.reg-success-info-link:hover {
  color: #1c60ea;
}

.reg-success-info-link:focus-visible {
  outline: 2px solid #1c60ea;
  outline-offset: 2px;
  border-radius: 2px;
}

`, "",{"version":3,"sources":["webpack://./../shared/styles/RegistrationSuccess.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB,EAAE,gBAAgB;EAClC,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Registration Success Shared Component Styles */\n\n.reg-success-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n.reg-success-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  width: 100%;\n  max-width: 728px;\n  min-width: 0;\n  overflow-x: visible;\n  overflow-y: visible;\n  box-sizing: border-box;\n  padding: 0 20px;\n}\n\n@media (min-width: 768px) {\n  .reg-success-content {\n    padding: 0;\n  }\n}\n\n.reg-success-message {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.5;\n  color: #00254a;\n  text-align: center;\n  margin: 0;\n}\n\n.reg-success-school-name {\n  font-weight: 600;\n}\n\n.reg-success-codes-container {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .reg-success-codes-container {\n    flex-direction: row;\n    gap: 40px;\n    justify-content: center;\n  }\n}\n\n.reg-success-email-notice {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 18px;\n  font-style: normal;\n  line-height: 1.5; /* 150% = 27px */\n  color: #00254a;\n  text-align: center;\n  margin: 0;\n}\n\n.reg-success-code-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n  min-width: 0;\n}\n\n.reg-success-code-label {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #1c60ea;\n  text-align: center;\n  margin: 0;\n  width: 100%;\n}\n\n.reg-success-code-card {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.reg-success-code-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  padding: 12px 24px;\n  background: #ffffff;\n  border: none;\n  border-radius: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 0;\n}\n\n.reg-success-code-button:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(35, 108, 255, 0.15);\n}\n\n.reg-success-code-button:active {\n  transform: scale(0.98);\n}\n\n.reg-success-code-button:focus-visible {\n  outline: 2px solid #1c60ea;\n  outline-offset: 2px;\n}\n\n.reg-success-code-text {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 1.3;\n  color: #1c60ea;\n  white-space: nowrap;\n}\n\n@media (min-width: 768px) {\n  .reg-success-code-text {\n    font-size: 40px;\n  }\n}\n\n.reg-success-copy-icon {\n  width: 28px;\n  height: 28px;\n  color: #1c60ea;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (min-width: 768px) {\n  .reg-success-copy-icon {\n    width: 36px;\n    height: 36px;\n  }\n}\n\n.reg-success-copied-feedback {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #1c60ea;\n  background: rgba(255, 255, 255, 0.95);\n  padding: 4px 12px;\n  border-radius: 12px;\n  pointer-events: none;\n  animation: fadeInOut 2s ease-in-out;\n}\n\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.reg-success-code-description {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #00254a;\n  text-align: center;\n  margin: 0;\n  max-width: 272px;\n}\n\n.reg-success-button-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .reg-success-button-container {\n    flex-direction: row;\n    justify-content: center;\n    gap: 24px;\n  }\n}\n\n.reg-success-done-button {\n  width: 220px;\n  height: 48px;\n  padding: 10px 24px !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 1.75em !important;\n  border-radius: 9999px !important;\n  background-color: transparent !important;\n  color: #00254a !important;\n  border: 2px solid #00254a !important;\n  cursor: pointer;\n  transition: all 0.2s ease !important;\n  white-space: nowrap;\n}\n\n.reg-success-done-button:hover:not(:disabled) {\n  background-color: rgba(0, 37, 75, 0.05) !important;\n}\n\n.reg-success-done-button:active:not(:disabled) {\n  background-color: rgba(0, 37, 75, 0.1) !important;\n}\n\n.reg-success-view-challenge-button {\n  width: 220px;\n  height: 48px;\n  padding: 10px 24px !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 1.75em !important;\n  border-radius: 9999px !important;\n  background-color: #205ea3 !important;\n  color: white !important;\n  border: none !important;\n  cursor: pointer;\n  transition: all 0.2s ease !important;\n  white-space: nowrap;\n}\n\n.reg-success-view-challenge-button:hover:not(:disabled) {\n  background-color: #1a4d8a !important;\n}\n\n.reg-success-view-challenge-button:active:not(:disabled) {\n  background-color: #154071 !important;\n}\n\n\n.reg-success-info-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 30px;\n  background: rgba(35, 108, 255, 0.07);\n  border-radius: 30px;\n  overflow: hidden;\n}\n\n.reg-success-info-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0;\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .reg-success-info-content {\n    flex-direction: row;\n    align-items: center;\n    gap: 24px;\n  }\n}\n\n.reg-success-info-question {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 1.5;\n  color: #1c60ea;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.reg-success-info-contact {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1.5;\n  color: #00254a;\n  flex: 1;\n}\n\n.reg-success-info-link {\n  color: #00254a;\n  text-decoration: underline;\n  text-decoration-skip-ink: none;\n  text-underline-position: from-font;\n  font-weight: 600;\n  transition: color 0.2s ease;\n}\n\n.reg-success-info-link:hover {\n  color: #1c60ea;\n}\n\n.reg-success-info-link:focus-visible {\n  outline: 2px solid #1c60ea;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
